import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Logo Section */}
      <div className="text-center mb-6">
        <img src="/logo.png" alt="Logo" className="w-32 h-auto mx-auto" />
      </div>

      <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
      <p className="text-gray-700 text-sm mb-4">Updated at 04/06/2025.</p>

      <div className="space-y-6">
        <p>
          Golden Gate Global Myanmar PTE., LTD built the MSME app as a commercial app. This SERVICE is provided by Golden Gate Global Myanmar PTE., LTD and is intended for use as is.
        </p>
        <p>
          This page informs visitors about our policies regarding the collection, use, and disclosure of Personal Information if anyone decides to use our Service.
        </p>
        <p>
          By using our Service, you agree to the collection and use of information in accordance with this policy. The Personal Information we collect is used to provide and improve the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
        </p>

        {/* Information Collection and Use */}
        <h3 className="text-2xl font-semibold">Information Collection and Use</h3>
        <p>
          For a better experience while using our Service, we may require you to provide certain personally identifiable information. The information requested will be retained by us and used as described in this Privacy Policy.
        </p>
        <p>
          The app may use third-party services that collect information used to identify you. Links to the privacy policies of these third-party service providers are provided below:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li><a href="https://www.uab.com.mm/suspdf/Responsible_Business/Compliance/Statement%20on%20Privacy/Statement%20on%20Privacy.pdf" target="_blank" className="text-green-600">UAB Privacy Policy</a></li>
          <li><a href="https://www.atom.com.mm/en/about/privacy-policy" target="_blank" className="text-green-600">Atom Privacy Policy</a></li>
          <li><a href="https://aws.amazon.com/privacy/?nc1=f_pr" target="_blank" className="text-green-600">AWS Privacy Policy</a></li>
        </ul>

        {/* Log Data */}
        <h3 className="text-2xl font-semibold">Log Data</h3>
        <p>
          In case of an error or app crash, we collect data and information (“Log Data”) on your device through third-party products. This Log Data may include your device IP address, device name, operating system version, app configuration when using the Service, timestamps of usage, and other diagnostic data.
        </p>

        {/* Cookies */}
        <h3 className="text-2xl font-semibold">Cookies</h3>
        <p>
          Cookies are files with a small amount of data commonly used as anonymous unique identifiers. They are sent to your device from websites you visit and stored in your device’s internal memory.
        </p>
        <p>
          Our Service does not explicitly use cookies. However, third-party code and libraries integrated into the app may use cookies to collect information and improve their services. You can accept or refuse cookies via your device or browser settings. Refusing cookies may limit certain features of the Service.
        </p>

        {/* Service Providers */}
        <h3 className="text-2xl font-semibold">Service Providers</h3>
        <p>
          We may employ third-party companies and individuals for the following reasons:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related tasks;</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <p>
          These third parties have access to your Personal Information only to perform assigned tasks on our behalf and are obligated not to disclose or use it for other purposes.
        </p>

        {/* Security */}
        <h3 className="text-2xl font-semibold">Security</h3>
        <p>
          We value your trust in providing us your Personal Information and strive to use commercially acceptable measures to protect it. However, no method of transmission over the internet or electronic storage is completely secure, so we cannot guarantee absolute security.
        </p>

        {/* Links to Other Sites */}
        <h3 className="text-2xl font-semibold">Links to Other Sites</h3>
        <p>
          Our Service may contain links to third-party sites. Clicking on these links will direct you to those sites. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of third-party sites or services. We recommend reviewing their privacy policies when visiting them.
        </p>

        {/* Children’s Privacy */}
        <h3 className="text-2xl font-semibold">Children’s Privacy</h3>
        <p>
          Our Service is not directed to individuals under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If we become aware that a child under 13 has provided us with personal data, we will take immediate steps to delete it. If you are a parent or guardian and know that your child has provided us with personal information, please contact us.
        </p>

        {/* Information Security */}
        <h3 className="text-2xl font-semibold">Information Security</h3>
        <p>
          We implement strict policies and security measures to protect your data from unauthorized access or disclosure. Access to personal data is limited to employees, contractors, and agents who need it to perform services on our behalf and are bound by confidentiality obligations.
        </p>

        {/* Changes to This Privacy Policy */}
        <h3 className="text-2xl font-semibold">Changes to This Privacy Policy</h3>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any significant changes through the app or via email. Your continued use of the Service after changes constitutes your acceptance of the updated policy.
        </p>

        {/* User Data Deletion */}
        <h3 className="text-2xl font-semibold">User Data Deletion</h3>
        <p>
          You have the right to request deletion of your personal information at any time. To request deletion, please contact us at: <a href="mailto:info@msmebyg3g.com" className="text-green-600">info@msmebyg3g.com</a>.
        </p>

        <p>
          We retain your data only as long as necessary to provide the Service or comply with legal requirements. Upon deletion requests, we will remove your data from our active systems and request third parties who received your data to delete it as well.
        </p>

        {/* Contact Us */}
        <h3 className="text-2xl font-semibold">Contact Us</h3>
        <p>
          If you have questions or concerns regarding this Privacy Policy, please contact us at: <a href="mailto:info@msmebyg3g.com" className="text-green-600">info@msmebyg3g.com</a>.
        </p>
      </div>
      {/* Footer Section */}
      <footer className="text-center mt-16 text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} MSME. All Rights Reserved.</p>
      </footer>
    </div>
  );
}
